<section class="bookin-form-page">
  <div class="container">
  
   <div class="row">
     <div class="col-lg-7 booking-main">
      <div class="row">
        <div class="col-12 text-left">
          <h1 class="text-left">Complete your <span>booking</span></h1>
          <p class="booking-page-intro">Choose your pickup details and vehicle, then review your trip before booking.</p>
        </div>
      </div>
      <mat-card class="booking-card">
        <div class="bordered booking-section">
        <h2 class="section-title">Pickup details</h2>
        <div class="row" id="scheduled">
          <div class="col-md-6">
            
            <mat-form-field appearance="outline" class="w-100" >
              <mat-label>Pick Up Date</mat-label>
              <input matInput #date [(ngModel)]="pickupDate" [matDatepicker]="picker" [min]="minDate"  (click)="picker.open()"  (dateChange)="ondatechange()"  id="pdate" 
              autocomplete="off">
              <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline"  class="w-100">
              <mat-label >Pick Up Time</mat-label>
              <mat-select #time [(value)]="pickupTime">
                <mat-option value="00:00">12.00 AM</mat-option>
                <mat-option value="00:15">12.15 AM</mat-option>
                <mat-option value="00:30">12.30 AM</mat-option>
                <mat-option value="00:45">12.45 AM</mat-option>
                <mat-option value="01:00">01.00 AM</mat-option>
                <mat-option value="01:15">01.15 AM</mat-option>
                <mat-option value="01:30">01.30 AM</mat-option>
                <mat-option value="01:45">01.45 AM</mat-option>
                <mat-option value="02:00">02.00 AM</mat-option>
                <mat-option value="02:15">02.15 AM</mat-option>
                <mat-option value="02:30">02.30 AM</mat-option>
                <mat-option value="02:45">02.45 AM</mat-option>
                <mat-option value="03:00">03.00 AM</mat-option>
                <mat-option value="03:15">03.15 AM</mat-option>
                <mat-option value="03:30">03.30 AM</mat-option>
                <mat-option value="03:45">03.45 AM</mat-option>
                <mat-option value="04:00">04.00 AM</mat-option>
                <mat-option value="04:15">04.15 AM</mat-option>
                <mat-option value="04:30">04.30 AM</mat-option>
                <mat-option value="04:45">04.45 AM</mat-option>
                <mat-option value="05:00">05.00 AM</mat-option>
                <mat-option value="05:15">05.15 AM</mat-option>
                <mat-option value="05:30">05.30 AM</mat-option>
                <mat-option value="05:45">05.45 AM</mat-option>
                <mat-option value="06:00">06.00 AM</mat-option>
                <mat-option value="06:15">06.15 AM</mat-option>
                <mat-option value="06:30">06.30 AM</mat-option>
                <mat-option value="06:45">06.45 AM</mat-option>
                <mat-option value="07:00">07.00 AM</mat-option>
                <mat-option value="07:15">07.15 AM</mat-option>
                <mat-option value="07:30">07.30 AM</mat-option>
                <mat-option value="07:45">07.45 AM</mat-option>
                <mat-option value="08:00">08.00 AM</mat-option>
                <mat-option value="08:15">08.15 AM</mat-option>
                <mat-option value="08:30">08.30 AM</mat-option>
                <mat-option value="08:45">08.45 AM</mat-option>
                <mat-option value="09:00">09.00 AM</mat-option>
                <mat-option value="09:15">09.15 AM</mat-option>
                <mat-option value="09:30">09.30 AM</mat-option>
                <mat-option value="09:45">09.45 AM</mat-option>
                <mat-option value="10:00">10.00 AM</mat-option>
                <mat-option value="10:15">10.15 AM</mat-option>
                <mat-option value="10:30">10.30 AM</mat-option>
                <mat-option value="10:45">10.45 AM</mat-option>
                <mat-option value="11:00">11.00 AM</mat-option>
                <mat-option value="11:15">11.15 AM</mat-option>
                <mat-option value="11:30">11.30 AM</mat-option>
                <mat-option value="11:45">11.45 AM</mat-option>
                <mat-option value="12:00">12.00 PM</mat-option>
                <mat-option value="12:15">12.15 PM</mat-option>
                <mat-option value="12:30">12.30 PM</mat-option>
                <mat-option value="12:45">12.45 PM</mat-option>
                <mat-option value="13:00">01.00 PM</mat-option>
                <mat-option value="13:15">01.15 PM</mat-option>
                <mat-option value="13:30">01.30 PM</mat-option>
                <mat-option value="13:45">01.45 PM</mat-option>
                <mat-option value="14:00">02.00 PM</mat-option>
                <mat-option value="14:15">02.15 PM</mat-option>
                <mat-option value="14:30">02.30 PM</mat-option>
                <mat-option value="14:45">02.45 PM</mat-option>
                <mat-option value="15:00">03.00 PM</mat-option>
                <mat-option value="15:15">03.15 PM</mat-option>
                <mat-option value="15:30">03.30 PM</mat-option>
                <mat-option value="15:45">03.45 PM</mat-option>
                <mat-option value="16:00">04.00 PM</mat-option>
                <mat-option value="16:15">04.15 PM</mat-option>
                <mat-option value="16:30">04.30 PM</mat-option>
                <mat-option value="16:45">04.45 PM</mat-option>
                <mat-option value="17:00">05.00 PM</mat-option>
                <mat-option value="17:15">05.15 PM</mat-option>
                <mat-option value="17:30">05.30 PM</mat-option>
                <mat-option value="17:45">05.45 PM</mat-option>
                <mat-option value="18:00">06.00 PM</mat-option>
                <mat-option value="18:15">06.15 PM</mat-option>
                <mat-option value="18:30">06.30 PM</mat-option>
                <mat-option value="18:45">06.45 PM</mat-option>
                <mat-option value="19:00">07.00 PM</mat-option>
                <mat-option value="19:15">07.15 PM</mat-option>
                <mat-option value="19:30">07.30 PM</mat-option>
                <mat-option value="19:45">07.45 PM</mat-option>
                <mat-option value="20:00">08.00 PM</mat-option>
                <mat-option value="20:15">08.15 PM</mat-option>
                <mat-option value="20:30">08.30 PM</mat-option>
                <mat-option value="20:45">08.45 PM</mat-option>
                <mat-option value="21:00">09.00 PM</mat-option>
                <mat-option value="21:15">09.15 PM</mat-option>
                <mat-option value="21:30">09.30 PM</mat-option>
                <mat-option value="21:45">09.45 PM</mat-option>
                <mat-option value="22:00">10.00 PM</mat-option>
                <mat-option value="22:15">10.15 PM</mat-option>
                <mat-option value="22:30">10.30 PM</mat-option>
                <mat-option value="22:45">10.45 PM</mat-option>
                <mat-option value="23:00">11.00 PM</mat-option>
                <mat-option value="23:15">11.15 PM</mat-option>
                <mat-option value="23:30">11.30 PM</mat-option>
                <mat-option value="23:45">11.45 PM</mat-option>

              </mat-select>
            </mat-form-field>

                <!-- <div class="min-time-example">
                  <input placeholder="Starting Time"
                      [ngxTimepicker]="min" 
                      [min]="minTime | date:'shortTime'"   
                      class="timepkr" #time  readonly>
                  <ngx-material-timepicker #min></ngx-material-timepicker>
              </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-12" *ngIf="ttype === 'roundtrip'"></div>
          <div class="col-md-6" *ngIf="ttype === 'roundtrip'">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Round Trip Waiting</mat-label>
              <mat-select [(value)]="roundtripWaiting" #roundtripWaitings (selectionChange)="onroundtripWaitingchange(roundtripWaitings.value)">
                <mat-option value="15">15 Minutes</mat-option>
                <mat-option value="30">30 Minutes</mat-option>
                <mat-option value="45">45 Minutes</mat-option>
                <mat-option value="60">1 Hour</mat-option>
                <mat-option value="75">1.15 Hours</mat-option>
                <mat-option value="90">1.30 Hours</mat-option>
                <mat-option value="105">1.45 Hours</mat-option>
                <mat-option value="120">2 Hours</mat-option>
                <mat-option value="135">2.15 Hours</mat-option>
                <mat-option value="150">2.30 Hours</mat-option>
                <mat-option value="165">2.45 Hours</mat-option>
                <mat-option value="180">3 Hours</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label >Number of passengers</mat-label>
              <mat-select id="nopcenter" #passengers (selectionChange)="onPassengerchange(passengers.value)">
                <mat-option>None</mat-option>
                <mat-option value="1">1</mat-option>
                <mat-option value="2">2</mat-option>
                <mat-option value="3">3</mat-option>
                <mat-option value="4">4</mat-option>
                <mat-option value="5">5</mat-option>
                <mat-option value="6">6</mat-option>
                <mat-option value="7">7</mat-option>
                <mat-option value="8">8</mat-option>
                <mat-option value="9">9</mat-option>
                <mat-option value="10">10</mat-option>
                <mat-option value="11">11</mat-option>
                <mat-option value="12">12</mat-option>
                <mat-option value="13">13</mat-option>
                <mat-option value="14">14</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
        </div>
        <div class="row" id="outstation-field">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100" >
              <mat-label>Return Date</mat-label>
              <input matInput #returndate [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open()">
              <mat-datepicker-toggle matSuffix [for]="picker2" ></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Return Time</mat-label>
              <input matInput #returntime  id="returntime" type="time">
            </mat-form-field>
          </div>
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Number of days of waiting</mat-label>
              <input matInput #nowdays type="number"  (change)="waitingdays(nowdays.value)">
            </mat-form-field>
          </div>
        </div>
        </div>
        <div class="bordered booking-section vehicle-section">
        <div class="row">
          <div class="col-12 text-center pl-0 pr-0">
              <h2 class="section-title text-center">Choose your vehicle</h2>
              <mat-radio-group [(ngModel)]="vehicletype" (change)="vehiclechange()">
                    <mat-label id="suv">
                      <mat-radio-button class="buttonradio" value="suv">
                        <img width="100" src="assets/images/suv.png">
                        <img width="100" src="assets/images/suv-active.png" class="active">
                        <p>SUV / Sedan</p>
                        <small class="vehicle-capacity d-none">Max 4 passengers</small>
                      </mat-radio-button>
                    </mat-label>
                    <mat-label id="outstation">
                      <mat-radio-button class="buttonradio" value="Mini van">
                        <img width="100" src="assets/images/outstation.png">
                        <img width="100" src="assets/images/outstation-active.png" class="active">
                        <p>Mini Van</p>
                        <small class="vehicle-capacity d-none">Max 7 passengers</small>
                      </mat-radio-button>
                    </mat-label>
                    <mat-label id="truck">
                      <mat-radio-button class="buttonradio" value="truck">
                        <img width="100" src="assets/images/truck.png">
                        <img width="100" src="assets/images/truck-active.png" class="active">
                        <p>Truck</p>
                        <small class="vehicle-capacity d-none">Max 5 passengers</small>
                      </mat-radio-button>
                    </mat-label>
                    <mat-label id="passengervan">
                      <mat-radio-button class="buttonradio" value="passenger van">
                        <img width="100" src="assets/images/passenger-van.png">
                        <img width="100" src="assets/images/passenger-van-active.png" style="margin:0px auto;" class="active">
                        <p>Passenger Van</p>
                        <small class="vehicle-capacity d-none">Max 14 passengers</small>
                      </mat-radio-button>
                    </mat-label>
                </mat-radio-group>

                <!-- Trailer Towing -->
                <div class="trailer-towing-row mt-3" *ngIf="vehicletype !== 'suv'">
                  <mat-checkbox [(ngModel)]="trailerTowing" (change)="calculate()">
                    Trailer Towing &nbsp;<small class="text-muted">(+$0.20 / mile)</small>
                  </mat-checkbox>
                </div>
          </div>
          <div class="col-md-3"></div>
          
          <div class="col-md-6 driverprefer pt-2" id="dpr1">
              <p *ngIf="checkfavdrvr==false" class="text-center">No favourite drivers</p>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label *ngIf="checkfavdrvr==false">Preferred Driver</mat-label>
              <mat-label *ngIf="checkfavdrvr==true">Favourite Driver</mat-label>
              <mat-select name="driverprefer[]" #prefferddriver multiple>
                <div *ngIf="checkfavdrvr==true; else elseBlockz">
                  <div *ngFor="let e of slctli">
                      <div  *ngIf="e.favourite=='1'" >
                        <mat-option [value]="e.id+'/'+e.name" >{{ e.name }}</mat-option>
                      </div>
                  </div>
                </div>
                <ng-template #elseBlockz>
                  <mat-option *ngFor="let e of slctli" [value]="e.id+'/'+e.name" >{{ e.name }}</mat-option>
                </ng-template>
              </mat-select>
            </mat-form-field>
            
            <div class="driverprefer">
              <mat-checkbox class="example-margin" *ngIf="checkfavdrvr==false"  [(ngModel)]="checked2">Add preferred driver to favourite drivers</mat-checkbox>
            </div>
          </div>
          <div class="col-md-3 driverprefer"></div>
          <div class="col-md-12">
            <hr>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-8  pt-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Notes for your driver (optional)</mat-label>
              <textarea matInput placeholder="" #comment></textarea>
            </mat-form-field>
          </div>
          </div>
          </div>
          <div class="bordered notregistered" id="bookingAuthSection">
            <div class="row">
              <div class="col-12">
                <section class="example-section">
                  <mat-checkbox class="example-margin" id="checkbx" #check (change)="checkchanged()">Already have an account</mat-checkbox>
                </section>
              </div>
              <div class="col-12 p-0 instantreg">
                <div class="row w-100 text-center p-0 m-0 mt-3">
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Full Name</mat-label>
                      <input matInput placeholder="" #name required>
                    </mat-form-field>
          
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Mobile</mat-label>
                      <input matInput placeholder="" #mobile  required>
                    </mat-form-field>
          
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Email</mat-label>
                      <input matInput placeholder="pat@example.com" #email type="email" required>
                    </mat-form-field>
          
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Password</mat-label>
                      <input matInput [type]="hide ? 'password' : 'text'" #password>
                      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
               <div class="consent-container">
                  <div class="consent-wrapper">
                    <mat-checkbox #consent required class="consent-checkbox"></mat-checkbox>
                    <div class="consent-text">
                    By checking the box and submitting this form, you consent to receive SMS text messages from TruLink at (330) 372-8824 to answer your questions, provide follow-up regarding ride scheduling, confirmations, driver arrival notifications, and general service updates. Message frequency may vary. Message and data rates may apply. You can reply STOP to opt out of further messaging or HELP for assistance, or call (330) 372-8824. Please see our Privacy Policy at
                      <a href="https://yodertoter.com/docs/privacy.html" target="_blank">Privacy Policy</a>
                      and Terms and Conditions at
                      <a href="https://yodertoter.com/#/terms-conditions" target="_blank">Terms & Conditions</a>.
                    </div>
                  </div>
                </div>
               
                </div>
              </div>
              <div class="col-12 p-0 instantlogin">
                <div class="row w-100 text-center p-0 m-0 mt-3">
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Phone</mat-label>
                    <input matInput minlength="10" maxlength="10"  #loginphone required>
                  </mat-form-field>
        
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" #loginpassword>
                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hide">
                      <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bordered" id="otp">
            <div class="row">
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>OTP</mat-label>
                    <input matInput placeholder="" #otp required>
                  </mat-form-field>
        
                </div>
                <div class="col-12 col-md-6">
                  <button mat-raised-button class="btn1 w-100 mt-0" (click)="generateOtp(mobile.value)">Resend OTP</button>
                </div>
            </div>
          </div>
          <div class="row ">
            <div class="col-12 notregistered">
              <p class="errormod" style="display:none;">
                All fields are required
              </p>
            </div>
          <div class="col-12 notregistered">
            <button mat-raised-button class="btn1 w-100 instantreg" (click)="register(name.value,mobile.value,email.value,password.value,otp.value,consent.checked)">Submit</button>
            <button mat-raised-button class="btn1 w-100 instantlogin"  (click)="login(loginphone.value,loginpassword.value)">Submit</button>
          </div>
         
          <!-- <div class="col-12 text-center pt-2">
            <mat-checkbox class="example-margin" [(ngModel)]="checked">I have read and agree to the <a href="https://yodertoter.com/#/terms-conditions" target="_blank">terms and conditions</a></mat-checkbox>
          </div> -->
          <div class="col-12 text-center" *ngIf="vehicletype == 'passenger van'">
            <div class="card pmessage p-2 py-4">
              <h2 class="mb-1"><b>Thank you for choosing our passenger van service.</b></h2>
              <p class="mb-0">
                Due to limited driver availability, <b>please call us to confirm before booking.</b> We appreciate your understanding!
              </p>
              <a href="tel:330-474-9507 ">
                <button mat-raised-button class="btn1 w-100">Call Now</button>
              </a>
            </div>
          </div>
          
          <div class="col-12 col-sm-8 mx-auto text-center registeresproceed" *ngIf="((totalPrice+validatedwalletUsageAmount) - validatedwalletUsageAmount) >= 1">
              <button mat-raised-button class="btn1 w-100" (click)="bookingstep2(date.value,time.value,passengers.value,returndate.value,returntime.value,nowdays.value,prefferddriver.value,'now',comment.value);" [disabled]="isButtonClicked">Continue to Checkout</button>
              <small class="d-block mt-2 text-muted">Your card won't be charged until your ride is completed.</small>
          </div>
            <div class="col-12 col-sm-8 mx-auto text-center registeresproceed" *ngIf="totalPrice === validatedwalletUsageAmount || ((totalPrice+validatedwalletUsageAmount) - validatedwalletUsageAmount) < 1">
          <button
            mat-raised-button
            class="btn1 w-100"
            (click)="bookingstep2(date.value, time.value, passengers.value, returndate.value, returntime.value, nowdays.value, prefferddriver.value, 'later', comment.value);"
            [disabled]="isButtonClicked">
            Book Now
          </button>
        </div>

          <!-- <div class="col-6 text-center registeresproceed">
            <button mat-raised-button class="btn1 w-100" (click)="bookingstep2(date.value,time.value,passengers.value,returndate.value,returntime.value,nowdays.value,prefferddriver.value,'later',comment.value);" [disabled]="isButtonClicked">Pay With Driver</button>
        </div> -->
          <div class="col-12">
            <div id="step2error">
              <p>abc</p>
            </div>
          </div>
        </div>
  
      </mat-card>
     </div>
     <div class="col-lg-5 summary-column">
      <div class="row">
        <div class="col-12 text-left">
          <h1 class="text-left">Review your <span>trip</span></h1>
        </div>
      </div>
      <mat-card class="pricing" id="pricing">
        <h2 class="section-title">Fare estimate</h2>
              
        <div class="pricedetails">
          <h6 class="d-none" id="trigcalc" *ngIf="checkrun<5">
            <p *ngIf="checkrun<5">{{triggerCalculate}}</p>
          </h6>
        </div>
        <div *ngIf="fareMessage" class="fare-message">
          <p>{{fareMessage}}</p>
        </div>
        <div class="pricedetails" *ngIf="!fareMessage">
          <h3 *ngIf="hasReturnTrip">Routes : <span>2 separate one-way trips</span></h3>
          <h3>{{hasReturnTrip ? 'Distance per route' : 'Total Distance'}} : <span>{{totalMiles}} Miles</span></h3>
          <h3>Mileage Charge : <span>${{chargeRound}}</span></h3>
          <h3>Base Charge : <span>$15.00</span></h3>
          <div *ngIf="trailerTowing && trailerCost > 0">
            <h3>Trailer Towing : <span>${{trailerCost | number:'1.2-2'}}</span></h3>
          </div>
          <h3>Total Waiting Charge : <span>${{waitingchargeRound}}</span></h3>
          <div *ngIf="roundTripwaitingcharge!=undefined && ttype=='roundtrip'">
            <h3>Round Trip Waiting Charge: <span>${{ roundTripwaitingcharge | number:'1.0-0' }}</span></h3>
          </div>
        </div>
        <div *ngIf="!fareMessage && promocodeAmount>0">
          <h3>Promocode Discount : <span>-${{promocodeAmount}}</span></h3>
        </div>
        <div *ngIf="!fareMessage && walletOtpVerified==true && walletUsageAmount>0">
          <h3>Applied Wallet Amount : <span>${{validatedwalletUsageAmount}}</span></h3>
        </div>
        <h3 *ngIf="!fareMessage">Subtotal : <span class="subtotal">${{totalPrice}}</span></h3>
        <!-- <p *ngIf="totalPrice==30"><small>* Minimum charge of $30 applied</small></p> -->
        <div *ngIf="!fareMessage && SpecialDayMessage!=''">
          <i>
            <p>
              {{SpecialDayMessage}}
            </p>
          </i>
        </div>
        <!-- <button id="updatebtn">Update</button> -->
      </mat-card>
      <mat-card class="wallet_box mb-3" id="wallet_box">
        <p class="option-title">Use wallet balance</p>
        <p class="option-help">Available balance: <strong>${{ wallet }}</strong></p>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Enter Wallet Amount</mat-label>
          <input
            matInput
            type="number"
            min="0"
            [max]="wallet"
            class="w-100"
            [(ngModel)]="walletUsageAmount"
            placeholder="e.g. 100"
            [readonly]="otpRequested"
          />
        </mat-form-field>

        <button
          mat-raised-button
          class="btn1 mt-0"
          (click)="submitWalletAmount()"
          *ngIf="!otpRequested"
        >
          Apply wallet amount
        </button>

        <div *ngIf="otpRequested">
          <mat-form-field appearance="outline" class="w-100 mt-2">
            <mat-label>Enter 4-digit OTP</mat-label>
            <input
              matInput
              type="text"
              maxlength="4"
              pattern="[0-9]*"
              class="w-100"
              [(ngModel)]="walletOtp"
              placeholder="Enter OTP"
            />
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            class="btn1 mt-2"
            (click)="confirmWalletUsage()"
          >
            Apply Wallet Amount
          </button>

          <button
            mat-stroked-button
            color="warn"
            class="btn1 mt-2"
            (click)="editWalletUsage()"
          >
            Edit Wallet Amount
          </button>
        </div>
      </mat-card>

      <mat-card class="tip_box mb-3" id="tip_box">
        <p class="option-title">Add a tip</p>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tip Amount</mat-label>
          <input
            matInput
            type="number"
            min="0"
            class="w-100"
            [(ngModel)]="tipAmount"
            placeholder="e.g. 50"
          />
        </mat-form-field>
        <button mat-raised-button class="btn1 mt-0" (click)="calculate()">Apply Tip</button>
      </mat-card>


      <mat-card class="promocode_box mb-3" id="promocode_box">
        <p class="option-title">Promo code</p>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Promocode</mat-label>
          <input matInput class="w-100"  [(ngModel)]="promocode">
        </mat-form-field>
        <button mat-raised-button class="btn1 mt-0" (click)="checkPromocode()">Apply</button>
      </mat-card>
      
      <mat-card class="b-summary" id="bsummary">
        <div class="row">
          <div class="col-12 summary-card-header">
            <h2 class="section-title">Route details</h2>
            <button mat-stroked-button class="edit-btn edit-route-btn" aria-label="Edit route details" (click)="editbSummary()">
              Edit route
              </button>
          </div>
          <div class="col-12 col-sm-6">
            <mat-form-field appearance="outline" class="readonly-wrapper w-100">
              <mat-label>Trip Type</mat-label>
              <mat-select [(value)]="ttype" class="" #ttypet>
                <mat-option value="oneway">Oneway</mat-option>
                <mat-option value="roundtrip">Round Trip</mat-option>
                <mat-option value="outstation">Long Distance</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6">
            <mat-form-field appearance="outline" class="readonly-wrapper w-100">
              <mat-label>Booking Type</mat-label>
              <mat-select [(value)]="btype" #btypet class="">
                <mat-option value="book">Book Now</mat-option>
                <mat-option value="schedule">Schedule</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>From</mat-label>
              <input matInput matGoogleMapsAutocomplete country="us" #from id="from">
            </mat-form-field>
          </div>
          <div class="col-12">
              <div *ngFor="let address of addresses; let i = index;" id="stopid{{i}}">
                  <div class="row">
                    <div class="col-6 pr-1">
                      
                      <mat-form-field appearance="outline" class=" readonly-wrapper w-100">
                          <mat-label>Stop {{i+1}}</mat-label>
                          <input matInput [(ngModel)]="address.address" value="{{addresses[i].stop_name}}" matGoogleMapsAutocomplete country="us" id="stopname{{i+1}}" name="address_{{address.id}}">
                        </mat-form-field>
                    </div>
                    <div class="col-4 pr-1">
                      <mat-form-field appearance="outline" class="readonly-wrapper" id="stopwait{{i+1}}">
                          <mat-label>Waiting Time</mat-label>
                          <select matNativeControl value="{{addresses[i].stop_waiting || 15}}">
                            <!-- <option value="{{addresses[i].stop_waiting || 15}}">
                              {{addresses[i].stop_waiting || 15}} Minutes
                            </option> -->
                            <option value="15">
                              15 Minutes
                            </option>
                            <option value="30">
                              30 Minutes
                            </option>
                            <option value="45">
                              45 Minutes
                            </option>
                            <option value="60">
                              1 Hour
                            </option>
                            <option value="75">
                              1.15 Hours
                            </option>
                            <option value="90">
                              1.30 Hours
                            </option>
                            <option value="105">
                              1.45 Hours
                            </option>
                            <option value="120">
                              2 Hours
                            </option>
                            <option value="135">
                              2.15 Hours
                            </option>
                              <option value="150">
                              2.30 Hours
                            </option>
                            <option value="165">
                              2.45 Hours
                            </option>
                            <option value="180">
                              3 Hours
                            </option>

                          </select>
                        </mat-form-field>
                    </div>
                    <div class="col-2 text-right pl-0">
                        <button mat-raised-button type="button" class="btn-remove readonly-wrapper" (click)="removeAddress(i)">
                          <mat-icon aria-hidden="false" aria-label="Example home icon">delete</mat-icon>
                        </button>
                    </div>
                  </div>
              </div>
              
              <label class="d-none">Enter waiting time if driver want to wait</label><br>
              <button mat-raised-button type="button" class="addbtn mb-2 text-center d-none" (click)="addAddress()">Add Stop <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon></button>
              
          </div>
          
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>To</mat-label>
              <input matInput matGoogleMapsAutocomplete country="us" #to id="to">
            </mat-form-field>
          </div>
          <div class="col-12" *ngIf="hasReturnTrip">
            <div class="return-route-summary">
              <strong>Separate return trip</strong>
              <span>{{returnPickupDate | date:'MMM d, y'}} at {{returnPickupTime}}</span>
              <p>Destination → reversed intermediate stops → pickup address</p>
            </div>
          </div>
          <div class="col-12 pb-3" id="error5">
            <p>
              All fields are required.
            </p>
          </div>
          <div class="col-md-6">
            <div class="example-button-container">
              <button mat-button   class="booknow" (click)="preBook(from.value,to.value,ttypet.value,btypet.value);">
                Update
              </button>
            </div>
          </div>
        </div>
      </mat-card>

     </div>
   </div>
  </div>
</section>
